import BaseEnum from "./base_enum.js";

class ProjectStatusEnumDesc extends BaseEnum {

  name() {
    return "project_status";
  }

  rawValues() {
    return ["upcoming", "financing", "fully_funded", "refunded"];
  }

}

const ProjectStatusEnum = new ProjectStatusEnumDesc();
export default ProjectStatusEnum;